import axios, { AxiosResponse } from "axios";
import Cookies from "js-cookie";

//Represents results of the /rest/external/product-category/{categoryCode}/products
//Example: /rest/external/product-category/ErectileDysfunction/products
//For ED the list will contain one item for each of the medication: 1 for sildenafil, 1 for viagra, etc.
export type ProductsForCategoryAPIResult = ProductType[];

//Represents a certain medication like viagra or sildenafil. In our DB model it matches the
//concept of ProductInformation. The id represent the medicineTypeCode, while the products represents
//the list of products for that medication. Eg. for viagra - there will be an entry for viagra25, one for viagra50
//one for viagra100
interface ProductType {
  id: string;
  products: Product[];
}

//Matches the concept of Product in our DB. The id represent the product code.
//Eg. sildenafil25, cialis10
interface Product {
  id: string;
  prices: ProductPrice[];
}

//Different quantities in which the product can be sold. Eg. 4 tablets for sildenafil25
interface ProductPrice {
  quantity: number;
  price: number;
  pricePerPill: number;
  priceWithDiscount: number;
}

export function findByMedicineType(
  categoryWithProducts: ProductsForCategoryAPIResult,
  medicineType: string
): ProductType {
  return categoryWithProducts.find((productType: ProductType) => productType.id === medicineType);
}

export function findByCodeAndQuantity(
  productType: ProductType,
  code: string,
  quantity: string
): ProductPrice | undefined {
  const product: Product = productType.products.find((product: Product) => product.id === code);
  if (!product) {
    return undefined;
  }
  return product.prices.find((price: ProductPrice) => price.quantity.toString() === quantity);
}

function getPromoCode(): string | undefined {
  const urlParams = new URLSearchParams(window.location.search);
  const promoCodeQueryParam = urlParams.get("promo-code");
  const promoCodeCookie = Cookies.get("medexpress-discount");
  return promoCodeQueryParam || promoCodeCookie || undefined;
}

function setForcePricesCookieIfNeeded() {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get("variant");

  if (variant === "base") {
    Cookies.set("forceBaseVariant", true, { path: "/" });
  }
}
export async function loadPrices(category: string): Promise<ProductsForCategoryAPIResult> {
  setForcePricesCookieIfNeeded();

  const promoCode = getPromoCode();
  const params = promoCode ? { promoCode } : {};
  const response: AxiosResponse = await axios.get(`/rest/external/product-category/${category}/products`, { params });
  return response.data;
}
